<template>
    <FilterModal :type="selectedStoreUuids.length === 0 ? 'btn-danger' : null"
                 :filterable="__('general.stores')"
                 :value="selectedStoreUuids.length"
    >
        <div class="d-flex flex-column gap-1">
            <div class="mb-4 d-flex flex-row gap-2">
<!--                <button class="btn btn-sm btn-secondary text-nowrap">-->
<!--                    Select All-->
<!--                </button>-->
<!--                <button class="btn btn-sm btn-secondary text-nowrap">-->
<!--                    Deselect All-->
<!--                </button>-->
                <div class="input-group">
                    <input type="text"
                           class="form-control form-control-sm form-control-solid"
                           placeholder="Search store"
                           v-model="search"
                    >
                    <div class="input-group-append">
                        <button class="btn btn-sm btn-secondary">
                            <i class="fas fa-trash"/>
                        </button>
                    </div>
                </div>
            </div>
            <div v-for="store in filteredStores"
                 :key="store.id"
                 class="bg-hover-light-primary rounded px-4 py-2"
            >
                <Checkbox v-model="selection[store.id]">
                    <Store class="ml-2" :store="stores[store.id]"/>
                </Checkbox>
            </div>
        </div>
    </FilterModal>
</template>

<script>
import FilterModal from "@components/Stats/FilterModal.vue";
import Checkbox from "@components/Form/Checkbox.vue";
import Store from "@components/Store/Store.vue";

export default {
    components: {Store, Checkbox, FilterModal},

    props: {
        stores: Object,
        value: Object
    },

    data() {
        return {
            selection: this.value,
            search: ''
        }
    },

    computed: {
        filteredStores() {
            let trimmedSearch = this.search.trim();

            if (trimmedSearch === '') {
                return this.stores;
            }

            return Object.values(this.stores).filter(store => {
                return store.attributes.name.toLowerCase().includes(trimmedSearch);
            });
        },

        selectedStoreUuids() {
            let storeUuids = [];

            for (let storeUuid in this.selection) {
                if (this.selection[storeUuid]) {
                    storeUuids.push(storeUuid);
                }
            }

            return storeUuids;
        }
    },

    watch: {
        selection(newValue, oldValue) {
            this.$emit('input', this.selectedStoreUuids)
        }
    }
}
</script>
